import { create } from "zustand";
import type { TaskType } from "../types";

interface TaskTypesState {
	modalOpen: boolean;
	editingItem: TaskType | null;
}

interface TaskTypesActions {
	openCreateModal: () => void;
	openEditModal: (item: TaskType) => void;
	onOpen: (item?: TaskType) => void;
	closeModal: () => void;
}

type TaskTypesStore = TaskTypesState & TaskTypesActions;

export const useTaskTypesStore = create<TaskTypesStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingItem: null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	onOpen: (item) => {
		set({ modalOpen: true, editingItem: item ?? null });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null });
	},
}));
